var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { makeObservable } from 'mobx';
import { sortedSet } from '../../../../../utils/mobx/decorators/customComputed';
import { traitCreatedBy } from '../../../../../registry/trait/TraitRegistryDependencies';
export class AspectKeyAttached {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get aspectKey() {
        return this.parent;
    }
    get aspect() {
        return this.aspectKey.aspect;
    }
    get attachedtraits_primary() {
        return this.aspectKey.keyTraits.map(trait => this.aspect.aspectAttached.toAttached(trait));
    }
    get attachedTraits_unsorted() {
        // const refreshOnNewPackage = runtime.availablePackages.allAvailablePackages;
        if (!this.aspectKey.reg)
            return [];
        return this.attachedtraits_primary.concat(...(traitCreatedBy[this.aspectKey.traitKey] || []).map(traitKey => {
            if (!traitKey) {
                console.log(`Bei einem traits reg eintrag mit derived key ${this.aspectKey.traitKey} fehlt das KEY Attribut!`);
                return [];
            }
            return this.aspectKey.aspectScope
                .aspectKey(traitKey)
                .keyAttached.attachedtraits_derived.filter(at => at.key === this.aspectKey.traitKey);
        }));
    }
    get attachedTraits() {
        return this.attachedTraits_unsorted.concat().sort((at1, at2) => at2.prio - at1.prio);
    }
    get derivedTraitsInSerializedForm() {
        let list = [];
        this.attachedtraits_primary.forEach(at => {
            const t = at.trait;
            if (t.reg && t.reg.createTraits) {
                const generatedTraits = t.reg.createTraitsOptimized(at.context);
                generatedTraits.forEach(createdTrait => {
                    if (!createdTrait.parent)
                        createdTrait.parent = at.aspect;
                    createdTrait.createdBy = at;
                    if (!createdTrait.priority)
                        createdTrait.priority = at.prio - 1;
                    if (!createdTrait.condition && at.trait.condition)
                        createdTrait.condition = at.trait.condition.serialized;
                });
                list = list.concat(generatedTraits);
            }
        });
        return list;
    }
    // @cachedSet --save memory 20181026--
    get attachedtraits_derived() {
        return this.derivedTraitsInSerializedForm.map((derivedTrait) => this.aspect.aspectAttached.toAttached(derivedTrait));
    }
}
__decorate([
    sortedSet
], AspectKeyAttached.prototype, "attachedtraits_primary", null);
__decorate([
    sortedSet
], AspectKeyAttached.prototype, "attachedTraits", null);
